import axios from 'axios'
import { prop } from 'ramda'

import { EmployeeCard } from './our-structure.types'

export const fetchEmployeeIntermezzo = (id: string, tabId: string): Promise<any> => {
    return axios
        .get(`/who-we-are/intermezzo/${id}/${tabId}`)
        .catch((e) => console.log('error', e))
        .then(prop('data'))
}

export const fetchEmployeeGrid = (id: string): Promise<EmployeeCard[] | undefined> => {
    return axios
        .get(`/who-we-are/employees/${id}`)
        .catch((e) => console.log('error', e))
        .then(prop('data'))
}

export const fetchFirstTabIdForEmployee = (id: string): Promise<any> => {
    return axios
        .get(`/who-we-are/employee/${id}`)
        .catch((e) => console.log('error', e))
        .then(prop('data'))
}
